import { useRecoilState } from "recoil";
import { hasSiteAtom, userInfoAtom } from "src/atoms";
import StepBarComponent from "components/Console/StepBar";
import { useRouter } from "src/hooks/useRouter";
import "./_Header.style.scss";
import ProductSwiper from "./SwitchSelector/_index";
import { ProductKey } from "src/config/config";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import { useIsOpenSelectProduct } from "src/hooks/recoil/useIsOpenSelectProduct";
import { useTranslation } from "react-i18next";

interface IHeaderUIProps {
  logout: any;
  path: any;
  goConsole: any;
  goBill: any;
  toggleContact: any;
  toggleContactOn: any;
  toggleUserMenu: any;
  toggleUserMenuOn: any;
  // setWrapperRef: any;
  noticeText: string | undefined;
  closeNoticeToday: () => void;
  closeNotice: () => void;
  navStep: any;
  product: ProductKey;
  // handleChangeForDropdown: any;
  isRenew: any;
  headerRef: React.RefObject<HTMLDivElement>;
  contactMenuRef: any;
  userMenuRef: any;
}

const HeaderUI = ({
  logout,
  path,
  goConsole,
  goBill,
  toggleContact,
  toggleContactOn,
  toggleUserMenu,
  toggleUserMenuOn,
  // setWrapperRef,
  noticeText,
  closeNoticeToday,
  closeNotice,
  navStep,
  product,
  // handleChangeForDropdown,
  isRenew,
  headerRef,
  contactMenuRef,
  userMenuRef,
}: IHeaderUIProps) => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [hasSite, setHasSite] = useRecoilState(hasSiteAtom);
  const { isOciProduct } = useIsOciProduct();
  const { isOpenSelectProduct, setIsOpenSelectProduct } =
    useIsOpenSelectProduct();
  const route = useRouter();
  const { t } = useTranslation();
  const { lang } = route;
  return (
    <>
      <div
        ref={headerRef}
        className={`topDiv ${navStep > 1 &&
          // hasSite === false &&
          path !== "bill" &&
          path !== "my-account" &&
          !isRenew
          ? noticeText
            ? "topDiv_notice_navStep"
            : "topDiv_navStep"
          : noticeText
            ? "topDiv_notice"
            : "topDiv_none"
          }`}
      >
        {noticeText && (
          <div className="mainNoticeBox">
            <div>{noticeText}</div>
            <div className="closeText">
              <span onClick={() => closeNoticeToday()}>
                {t("navBar.notifications.close")}
              </span>
            </div>
            <div className="closeButton">
              <a onClick={() => closeNotice()}>
                <i className="image" />
              </a>
            </div>
          </div>
        )}
        {path === "new" ? (
          ""
        ) : (
          <div
            className={`${noticeText ? "navbar_notice" : "navbar_non-notice"}`}
          >
            <header id="navbar" className="navbar_header">
              <div
                className="icon_fasoo main"
                onClick={() => {
                  setIsOpenSelectProduct((prev) => !prev);
                }}
              >
                {/* <div className="icon_fasoo main" onClick={goConsole}> */}
                {/* <a onClick={goConsole}></a> */}
              </div>
              {/* <div className={"navbar_switch"}>
                <ProductSwiper />
              </div> */}

              {/* <div ref={setWrapperRef} className="subMenu"> */}
              <div className="subMenu">
                <div
                  className="menu inline-block vertical-middle"
                  ref={contactMenuRef}
                >
                  <a onClick={() => toggleContact()}>
                    <i className="icon_circle_question" />
                  </a>
                  <div
                    className={`contact_center ${toggleContactOn ? "on" : ""}`}
                    style={{ width: "178px" }}
                  >
                    <a href={`mailto:cloud@fasoo.com`}>
                      <li className="menu_list">
                        {t("navBar.contact.contactSupport")}
                      </li>
                    </a>
                    {/* <a
                      href={`${
                        getProductFromSessionStorage() === "WRAPSODY"
                          ? `https://www.wrapsody.com/${
                              lang === "ko" ? "kr" : "en"
                            }/pricing/#FAQ`
                          : lang === "ko"
                          ? "https://www.wrapsodyeco.com/kr/price/#FAQ"
                          : "https://www.wrapsodyeco.com/en/plans-and-pricing/#FAQ"
                      }`}
                      target="_blank"
                    >
                      <li className="menu_list">
                        {t("navBar.contact.FAQ")}
                      </li>
                    </a> */}
                    {lang === "ko" && (
                      <a
                        href={`
                        https://chat.fasoo.com/cloud-cs
                      `}
                        target="_blank"
                      >
                        <li className="menu_list">
                          {t("navBar.contact.cloudCs")}
                        </li>
                      </a>
                    )}
                  </div>
                </div>
                <div
                  className="inline-block vertical-middle cursor-pointer"
                  ref={userMenuRef}
                >
                  <a onClick={() => toggleUserMenu()}>
                    <div className="userInfo">
                      {userInfo?.userName.substr(0, 2)}
                    </div>
                  </a>
                </div>
                <div
                  // ref={setWrapperRef}
                  className="userInfoMore cursor-pointer"
                >
                  {/* <a onClick={() => toggleUserMenu()}>
                    <i className="icon_user_info" />
                  </a> */}
                  <div
                    className={`userInfoMore_center ${toggleUserMenuOn ? "on" : ""
                      }`}
                  >
                    <div className="menu_list">
                      <div className="userInfoMore__profile">
                        {userInfo.userName.substr(0, 2)}
                      </div>
                      <div className="userInfoMore__info">
                        <span
                          className="userInfoMore__name"
                          title={userInfo.userName}
                        >
                          {userInfo.userName}
                        </span>
                        <span
                          className="userInfoMore__email"
                          title={userInfo.userId}
                        >
                          {userInfo.userId}
                        </span>
                      </div>
                    </div>
                    <div className="divider" />
                    <div className="menu_list1_container">
                      <div
                        className="menu_list1_item"
                        onClick={() => {
                          route.goMyAccount();
                          toggleUserMenu();
                        }}
                      >
                        {t("navBar.myAccount.fieldname")}
                      </div>
                      <div className="divider" />
                      <div
                        className="menu_list1_item logout"
                        onClick={() => logout()}
                      >
                        <span className="logout_text">
                          {t("navBar.myAccount.logout")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            {navStep > 1 &&
              isOciProduct &&
              hasSite === false &&
              path !== "bill" &&
              path !== "my-account" &&
              !isRenew && (
                <div
                  className={`topStepBar ${noticeText ? "topStepBar_notice" : "topStepBar_none"
                    }`}
                >
                  <StepBarComponent step={navStep} />
                </div>
              )}
          </div>
        )}
      </div>
      {/* <div
        className={`topMargin ${
          navStep > 1 &&
          hasSite === false &&
          path !== "bill" &&
          path !== "my-account" &&
          !isRenew
            ? noticeText
              ? "topMargin_notice_navStep"
              : "topMargin_navStep"
            : noticeText
            ? "topMargin_notice"
            : "topMargin_none"
        }`}
      ></div> */}
    </>
  );
};

export default HeaderUI;
